module.exports = __webpack_public_path__ + "static/babau-650322ac2d4bc56ec39e714fae091568.jpeg";